import { useQueries, useQuery, useQueryClient } from "@tanstack/react-query";

import { getRanaApiV1 } from "@nens/rana/api-v1";

import { ensureObjectUrlCleanup } from "./utils/ensure-object-url-cleanup";

// Single

const useEnsureProfileImageCleanup = () => {
  const queryClient = useQueryClient();
  ensureObjectUrlCleanup({
    queryClient,
    queryKeyPrefix: getProfileImageQuery("").queryKey.slice(0, -1),
    subscriptionKey: "profile-image-cleanup",
  });
};

const getProfileImageQuery = (userId?: string) => {
  return getRanaApiV1().getQueryOptions({
    queryKey: ["profile-image", userId],
    queryFn: async () => {
      if (!userId) return null;
      const response = await getRanaApiV1().UsersApi.userRetrieveImage({ id: userId });
      if (!response) return null;
      return URL.createObjectURL(response);
    },
    enabled: !!userId,
  });
};

export const useProfileImageQuery = (userId?: string) => {
  useEnsureProfileImageCleanup();
  return useQuery(getProfileImageQuery(userId));
};

export const useProfileImageQueries = (userIds: string[]) => {
  useEnsureProfileImageCleanup();
  return useQueries({ queries: userIds.map((userId) => getProfileImageQuery(userId)) });
};

// INVALIDATION

export const useInvalidateProfileImageQuery = () => {
  const queryClient = useQueryClient();

  useEnsureProfileImageCleanup();

  return async (userId: string) => {
    await queryClient.invalidateQueries({
      queryKey: getProfileImageQuery(userId).queryKey,
      refetchType: "all",
    });
  };
};
